import moment from 'moment';
export class FaqService {
    static $inject = ['MessagingHubService', 'AuthenticationService'];
    // Explicit AngularJS DI annotation for minification safety
    constructor(MessagingHubService, AuthenticationService) {
        'ngInject';
        this.messagingHubService = MessagingHubService;
        this.authenticationService = AuthenticationService;
    }
    //Intentions
    async registerIntention(faq) {
        const auth = this.authenticationService.auth;
        return this.messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/intention',
            resource: faq,
            metadata: {
                '#audit.id': faq.referenceName,
                '#audit.identity': auth.email,
            },
        });
    }
    async getIntentions({ skip = 0, take = 5, text = '' }) {
        return this.messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/intention?deleted=false&$take=${take}&$skip=${skip}&text=${text}`,
        });
    }
    async getIntention(id) {
        return this.messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/intention/${id}`,
        });
    }
    async getIntentionByReferenceName(referenceName) {
        return this.messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/intention/referenceName/${encodeURIComponent(referenceName)}`,
        });
    }
    async deleteIntention(id, referenceName) {
        const auth = this.authenticationService.auth;
        return this.messagingHubService.sendCommand({
            method: 'delete',
            to: 'postmaster@talkservice.msging.net',
            uri: `/intention/${id}`,
            metadata: {
                '#audit.id': referenceName,
                '#audit.identity': auth.email,
            },
        });
    }
    async getContext() {
        return this.messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: '/contexts',
        });
    }
    //Questions
    async getQuestions(id) {
        return this.messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/training?idRule=${id}`,
        });
    }
    async getUnknownQuestions({ skip = 0, take = 10 }) {
        const formatedDate = moment()
            .add(-7, 'days')
            .format('YYYY-MM-DD');
        return this.messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/request?startDate=${formatedDate}&minConfidence=0&maxConfidence=1&uncertain=true&$take=${take}&$skip=${skip}`,
        });
    }
    async setRequestFeedback(resource, referenceName) {
        const auth = this.authenticationService.auth;
        return this.messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/request',
            resource: resource,
            metadata: {
                '#audit.id': referenceName,
                '#audit.identity': auth.email,
            },
        });
    }
    async addQuestion(resource, referenceName) {
        const auth = this.authenticationService.auth;
        return this.messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/training',
            resource: resource,
            metadata: {
                '#audit.id': referenceName,
                '#audit.identity': auth.email,
            },
        });
    }
    async deleteUnknownQuestion(resource) {
        const auth = this.authenticationService.auth;
        return this.messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/request',
            resource: resource,
            metadata: {
                '#audit.id': resource.guid,
                '#audit.identity': auth.email,
            },
        });
    }
    async trainSet(application) {
        const auth = this.authenticationService.auth;
        return this.messagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.identity',
            to: 'postmaster@talkservice.msging.net',
            uri: '/contexts/training',
            resource: {},
            metadata: {
                '#audit.id': application.shortName,
                '#audit.identity': auth.email,
            },
        });
    }
    async publishSet(application) {
        const auth = this.authenticationService.auth;
        return this.messagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.identity',
            to: 'postmaster@talkservice.msging.net',
            uri: '/contexts/publish',
            resource: {},
            metadata: {
                '#audit.id': application.shortName,
                '#audit.identity': auth.email,
            },
        });
    }
}
